import React, { createContext, useContext, useState } from 'react'

const Context = createContext<[LocalStorage, (name: string, value: string | null) => void]>([{}, (name: string, value: string | null) => {
    // empty initialized values
}]);

interface LocalStorage {
    [key: string]: string | null
}

interface LocalStorageContext {
    children: any
    defaultValues: LocalStorage
}

export default function LocalStorage(props: LocalStorageContext) {

    const getDefaults = (values: LocalStorage): LocalStorage => {
        Object.keys(values).forEach((key: string) => {
            const temp = localStorage.getItem(key)
            if(temp) {
                values[key] = temp
            }
        })
        return values
    }

    const [state, setState] = useState(getDefaults(props.defaultValues));

    return (
        <Context.Provider value={[state, (name: string, value: string | null) => {
            setState((o) => {
                const out = {...o, [name]: value}
                if(value) {
                    localStorage.setItem(name, value);
                } else {
                    localStorage.removeItem(name);
                }
                return out
            })
        }]}>
            {props.children}
        </Context.Provider>
    )
}

export function useLocalStorage(name: string): [string | null, (val: string | null) => void] {
    const out = useContext(Context);
    return [out[0][name], (val: string | null) => {
        out[1](name, val)
    }]
}

export function useLocalStorageWithParsing<V>(name: string, nullValue: V): [V, (val: V) => void] {
    const [val, set] =  useLocalStorage(name)
    const setter = (val: V): void => {
        if(val === nullValue) {
            set(null);
        }
        set(JSON.stringify(val))
    }
    if(val) {
        try {
            return [JSON.parse(val) as V, setter]
        } catch(_) {
        }
    }
    return [nullValue, setter]
}